// ===================== COUNTDOWN =====================
(function(){
  var end = Date.now() + 5*60*1000;
  function tick(){
    var el = document.getElementById('up-timer');
    if(!el) return;
    var rem = Math.max(0, end - Date.now());
    var m = Math.floor(rem/60000);
    var s = Math.floor((rem%60000)/1000);
    el.textContent = ('0'+m).slice(-2)+':'+('0'+s).slice(-2);
    if(rem > 0) setTimeout(tick, 1000);
  }
  document.addEventListener('DOMContentLoaded', tick);
})();

// ===================== HERO GALLERY =====================
var _uImgs = [
  'https://cdn.shopify.com/s/files/1/0820/9380/1809/files/microcorriente-con-luz-roja-regenerativa-1632535.png?v=1778406270',
  'https://cdn.shopify.com/s/files/1/0820/9380/1809/files/microcorriente-con-luz-roja-regenerativa-1080899.png?v=1778406270',
  'https://cdn.shopify.com/s/files/1/0820/9380/1809/files/microcorriente-con-luz-roja-regenerativa-9041412.png?v=1778406270',
  'https://cdn.shopify.com/s/files/1/0820/9380/1809/files/microcorriente-con-luz-roja-regenerativa-2142459.png?v=1778406269',
  'https://cdn.shopify.com/s/files/1/0820/9380/1809/files/microcorriente-con-luz-roja-regenerativa-5712569.png?v=1778406271',
  'https://cdn.shopify.com/s/files/1/0820/9380/1809/files/microcorriente-con-luz-roja-regenerativa-2103068.png?v=1778406268',
  'https://cdn.shopify.com/s/files/1/0820/9380/1809/files/microcorriente-con-luz-roja-regenerativa-8273451.webp?v=1778406267'
];
var _uIdx = 0;
function switchHeroU(i) {
  _uIdx = i;
  var img = document.getElementById('hero-img-u');
  if(img) img.src = _uImgs[i];
  document.querySelectorAll('#thumb-row-u .thumb').forEach(function(t,j){
    t.classList.toggle('active', j===i);
  });
}

// Swipe on hero
document.addEventListener('DOMContentLoaded', function(){
  var wrap = document.querySelector('#hero-wrap-u');
  if(!wrap) return;
  var sx=0, moved=false;
  wrap.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;moved=false;},{passive:true});
  wrap.addEventListener('touchmove',function(){moved=true;},{passive:true});
  wrap.addEventListener('touchend',function(e){
    if(!moved) return;
    var dx = e.changedTouches[0].clientX - sx;
    if(Math.abs(dx)<35) return;
    var next = dx<0 ? Math.min(_uIdx+1,_uImgs.length-1) : Math.max(_uIdx-1,0);
    if(next!==_uIdx) switchHeroU(next);
  },{passive:true});
});

// ===================== BUY =====================
function upsellBuy(n) {
  var btn = document.getElementById('up-cta-'+(n||1));
  var orig = btn ? btn.innerHTML : '';
  if(btn){ btn.innerHTML='Añadiendo...'; btn.disabled=true; }
  fetch('/cart/add.js',{
    method:'POST',
    headers:{'Content-Type':'application/json'},
    body:JSON.stringify({id:53727326273873,quantity:1})
  }).then(function(r){
    if(r.ok){ window.location.href='/checkout'; }
    else{ if(btn){btn.innerHTML=orig;btn.disabled=false;} }
  }).catch(function(){ if(btn){btn.innerHTML=orig;btn.disabled=false;} });
}

function declineOffer(){
  window.history.length > 1 ? window.history.back() : (window.location.href='/');
}

// bfcache reset
window.addEventListener('pageshow',function(e){
  if(!e.persisted) return;
  [1,2].forEach(function(n){
    var btn=document.getElementById('up-cta-'+n);
    if(btn){btn.innerHTML='TOMAR OFERTA';btn.disabled=false;}
  });
  fetch('/cart/clear.js',{method:'POST'}).catch(function(){});
});